export default __webpack_public_path__ + "static/media/science-round-image.068db2a2.png";